import type { Locale } from "@bloom/types";
import { baseCatalog } from "./catalog.ts";
import { interpolate } from "./format.ts";
import type { TFn, TranslationCatalog } from "./types.ts";

export function makeT(locale: Locale, overrides?: Partial<TranslationCatalog>): TFn {
  const merged: Record<string, string> = {
    ...baseCatalog[locale],
    ...overrides?.[locale],
  };
  return (key, vars) => {
    const template = merged[key];
    if (template === undefined) {
      const proc = (globalThis as { process?: { env?: { NODE_ENV?: string } } }).process;
      if (proc?.env?.NODE_ENV !== "production") {
        console.warn(`[i18n] missing key '${key}' for locale '${locale}'`);
      }
      return key;
    }
    return interpolate(template, vars);
  };
}

export function getCatalog(locale: Locale): Record<string, string> {
  return baseCatalog[locale];
}
